import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CiLock } from 'react-icons/ci';

interface IProps {
  path: string;
  id?: number;
  icon?: any;
  title: string;
  showSideNav: Boolean;
  className?: string;
  setShowSideNav?: any;
  setToggleDropdowns?: any;
  toggleDropdowns?: any;
}

const AsideLink: React.FC<IProps> = ({
  path,
  icon,
  id,
  title,
  showSideNav,
  setShowSideNav,
  setToggleDropdowns,
  toggleDropdowns,
}) => {
  const [isShown, setIsShown] = useState(false);
  const handleMouseEnter = () => {
    if (!showSideNav) {
      setIsShown(true);
    }
  };

  const handleMouseLeave = () => {
    if (!showSideNav) {
      setIsShown(false);
    }
  };
  const handleButtonClick = () => {
    if (!showSideNav) {
      setShowSideNav(true);
    }
  };

  const makeParentActive = (id: any) => {
    // const parentElements = document.querySelectorAll('.parent-active');
    setToggleDropdowns(title);
  };

  const Link = () => (
    <>
      <button
        className="relative z-[20]"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
          handleMouseLeave();
          handleButtonClick();
          makeParentActive(title);
        }}
      >
        <div
          className={`pl-6 z-10 bg-pure-white ${
            isShown ? 'hover:text-primary' : ''
          }`}
        >
          {icon}
        </div>
        {isShown && !showSideNav && (
          <span className=" capitalize  w-20 absolute top-[-50%]  left-[110%] bg-primary text-[white] rounded text-[12px] p-1 z-[5000]">
            {title}
          </span>
        )}
        {/* {isShown ? (
          <p className="text-sm text-[white] -ml-3">{title}</p>
        ) : (
          <>{icon}</>
        )} */}
      </button>
      <div
        className={`-z-10 text-base 	transition-[transform]  duration-500  ${
          !showSideNav && 'absolute translate-x-[-200px]  '
        }`}
      >
        <p>{title}</p>
      </div>
    </>
  );

  return path ? (
    <NavLink
      to={path !== '' ? path : '#'}
      className={`flex  flex-nowrap min-w-max  max-w-full items-center space-x-4 capitalize
      ${toggleDropdowns === title ? 'font-medium' : 'font-normal'}
      ${toggleDropdowns === title ? 'text-primary' : 'text-light-grey'}
      `}
      onClick={() => {
        makeParentActive(title);
      }}
    >
      <Link />
    </NavLink>
  ) : (
    <div
      className={`flex justify-between cursor-pointer mr-3 flex-nowrap min-w-max  max-w-full items-center space-x-4 capitalize text-light-gray`}
      // style={() => ({
      //   fontWeight: toggleDropdowns === title ? 500 : 400,
      //   color: toggleDropdowns === title ? '#4062FF' : '#7F8397',
      // })}
      // onClick={() => {
      //   makeParentActive(title);
      // }}
    >
      <div className="flex justify-between space-x-4 items-center">
        <Link />
      </div>
      <CiLock size={16} />
    </div>
  );
};
export default React.memo(AsideLink);
